'use client';

import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:localcoin": true
    });
  } catch (e) {}
}();
import { Content } from '@prismicio/client';
import React, { useState } from 'react';
import { Simplify } from '@/prismicio-types';
import FaqItem from '../FaqItem';
type Props = {
  items: Simplify<Content.FaqSliceDefaultItem>[];
  highlightIcon?: boolean;
};
const FAQList = t0 => {
  const $ = _c(11);
  const {
    items,
    highlightIcon
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [openedFAQ, setOpenedFaq] = useState(t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = index => () => setOpenedFaq(prev => prev.includes(index) ? prev.filter(item => item !== index) : [...prev, index]);
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const toggleItem = t2;
  let t3;
  if ($[2] !== highlightIcon || $[3] !== items || $[4] !== openedFAQ) {
    let t4;
    if ($[6] !== highlightIcon || $[7] !== openedFAQ) {
      t4 = (t5, index_0) => {
        const {
          header,
          copy
        } = t5;
        return <FaqItem toggleItem={toggleItem(index_0)} isOpen={openedFAQ.includes(index_0)} header={header} copy={copy} highlightIcon={highlightIcon} key={header} />;
      };
      $[6] = highlightIcon;
      $[7] = openedFAQ;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    t3 = items.map(t4);
    $[2] = highlightIcon;
    $[3] = items;
    $[4] = openedFAQ;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[9] !== t3) {
    t4 = <div data-sentry-component="FAQList" data-sentry-source-file="index.tsx">{t3}</div>;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};
export default FAQList;